import get from 'lodash/get';

import COLORS from '../constants/colors.constants';

export const getThemeColor = (colorPath = '') => get(COLORS, colorPath);
